import React from "react"
import Swiper from "swiper"

import openPicksShop from "../../utils/open-picks-shop"

class TopSearch extends React.Component {
  state = {
    place: "",
  }

  componentDidMount() {
    new Swiper(".top-search .swiper-container", {
      slidesPerView: 5,
      spaceBetween: 10,
      // Responsive breakpoints
      breakpoints: {
        // when window width is <= 768px
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
    })
  }

  onChangePlace = e => {
    this.setState({ place: e.target.value })
  }

  onKeyPressPlace = e => {
    if (e.key === "Enter") {
      this.searchShop()
    }
  }

  searchShop = () => {
    openPicksShop(this.state.place)
  }

  searchShopByArea = area => {
    openPicksShop(area)
  }

  render() {
    return (
      <div className="top-search">
        <div className="mt-20">
          <div className="search">
            <div className="field has-addons">
              <div className="control is-expanded">
                <input
                  className="input is-primary is-borderless is-shadowless"
                  type="text"
                  placeholder="地域名を入力にて店舗を探す.."
                  value={this.state.place}
                  onChange={this.onChangePlace}
                  onKeyPress={this.onKeyPressPlace}
                />
              </div>
              <div className="control">
                <a
                  className="button is-primary icon is-search"
                  onClick={e => {
                    this.searchShop()
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-20">
          <div className="areas">
            <div className="swiper-container">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <a
                    className="button"
                    onClick={e => {
                      this.searchShopByArea("渋谷駅")
                    }}
                  >
                    渋谷駅
                  </a>
                </div>
                <div className="swiper-slide">
                  <a
                    className="button"
                    onClick={e => {
                      this.searchShopByArea("六本木駅")
                    }}
                  >
                    六本木駅
                  </a>
                </div>
                <div className="swiper-slide">
                  <a
                    className="button"
                    onClick={e => {
                      this.searchShopByArea("大手町駅")
                    }}
                  >
                    大手町駅
                  </a>
                </div>
                <div className="swiper-slide">
                  <a
                    className="button"
                    onClick={e => {
                      this.searchShopByArea("目黒駅")
                    }}
                  >
                    目黒駅
                  </a>
                </div>
                <div className="swiper-slide">
                  <a
                    className="button"
                    onClick={e => {
                      this.searchShopByArea("赤坂駅")
                    }}
                  >
                    赤坂駅
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-20">
          <div className="caution">
            <small>
              対応店舗は順次拡大中。
            </small>
          </div>
        </div>
      </div>
    )
  }
}

export default TopSearch
